import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'FilterPipe',
})
export class FilterPipe implements PipeTransform {
    transform(items: any, args: any): any {
        return items.filter(function (snap) {
            return snap.name.toLowerCase().includes(args.toLowerCase());
        });
    }
}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/search/pipe.ts